import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import cn from 'classnames';

import Context from '@bibliocommons/context';

import './ModalHeader.scss';

export default function ModalHeader({ className, title, size }) {
  const { mobileApp } = useContext(Context);
  const classNames = cn('cp-modal-header', className, {
    'modal-header--mobile-app': mobileApp,
    [`modal-header--${size}`]: !!size
  });

  return (
    <header className={classNames}>
      <h2 className="modal-header__title">{title}</h2>
    </header>
  );
}

ModalHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.oneOf(['default', 'small', 'large'])
};
